import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import config from '../../../../../constants/config';
import { getRandomNumber } from '../../../../../utils/numUtils';

const getCardMoveClasses = (number, card) => {
  if (number === 0) {
    return [`${card}-card-drunk-move-up`, `${card}-card-drunk-move-down`]
  }
  else if (number === 1) {
    return [`${card}-card-drunk-move-left`, `${card}-card-drunk-move-right`]
  }
  else if (number === 2) {
    return [`${card}-card-drunk-move-down`, `${card}-card-drunk-move-up`]
  }
  else if (number === 3) {
    return [`${card}-card-drunk-move-right`, `${card}-card-drunk-move-left`]
  }
  else if (number === 4) {
    return [`${card}-card-drunk-move-up-2`, `${card}-card-drunk-move-down-2`]
  }
  else if (number === 5) {
    return [`${card}-card-drunk-move-left-2`, `${card}-card-drunk-move-right-2`]
  }
  else if (number === 6) {
    return [`${card}-card-drunk-move-down-2`, `${card}-card-drunk-move-up-2`]
  }
  else if (number === 7) {
    return [`${card}-card-drunk-move-right-2`, `${card}-card-drunk-move-left-2`]
  }
}

const Render2PlayerCards = React.memo(({
  currentTable, cardsAdded, myPos, currentTurn, tableIsInProgress, gameState, firstToGo, isDrunk,// isFullscreen, isWebVersion,
}) => {

  const [cardMoveClassesMiddle1, setCardMoveClassesMiddle1] = useState(getCardMoveClasses(getRandomNumber(0, 7), 'middle'));
  const [cardMoveClassesMiddle2, setCardMoveClassesMiddle2] = useState(getCardMoveClasses(getRandomNumber(0, 7), 'middle'));

  const items = [];

//  console.log('Render2PlayerCards', currentTable, cardsAdded, myPos, currentTurn, tableIsInProgress, gameState, firstToGo,);

  const cardStyle = {}

  if (myPos === 'player1') {
    // table cards
    Object.keys(currentTable).map((key, index) => {
      if (currentTable[key] && currentTable[key].player === 'player1') {
        items.push(<div id={`table-card-${currentTable[key].card}`} className={`table-card card student-card-0 card-order-${index} table-card-${currentTable[key].card}`} />);
      }
      if (currentTable[key] && currentTable[key].player === 'player2') {
        items.push(<div id={`table-card-${currentTable[key].card}`} className={`table-card card student-card-1 card-order-${index} table-card-${currentTable[key].card}`} />);
      }
      if (isDrunk) {
        if (currentTable[key] && currentTable[key].player === 'player1') {
          items.push(<div id={`table-card-${currentTable[key].card}`} className={`${cardMoveClassesMiddle1[1]} table-card card student-card-0 card-order-${index} table-card-${currentTable[key].card}`} style={{opacity: 0.5}} />);
        }
        if (currentTable[key] && currentTable[key].player === 'player2') {
          items.push(<div id={`table-card-${currentTable[key].card}`} className={`${cardMoveClassesMiddle2[1]} table-card card student-card-1 card-order-${index} table-card-${currentTable[key].card}`} style={{opacity: 0.5}} />);
        }
      }
      return null;
    });

    // table card backgrounds
    if (currentTable && currentTable.length <= 2) {
   //   console.log('Render2PlayerCards 2', gameState, currentTurn, currentTable.length);

      if ((gameState !== 'burry' && currentTurn === 'player1') || (gameState === 'burry' && firstToGo === 'player1')) {
        items.push(<div className="table-card table-card-bg student-card-0" />);
        if (currentTable.length < 1) {
          items.push(<div className="table-card table-card-bg-after student-card-1" />);
        }
      } else if ((gameState !== 'burry' && currentTurn === 'player2') || (gameState === 'burry' && firstToGo === 'player2')) {
        items.push(<div className="table-card table-card-bg student-card-0" />);
        if (currentTable.length < 1) {
          items.push(<div className="table-card table-card-bg-after student-card-1" />);
        }
      }
    }

    return (
      <div className={`table-cards table-cards-student ${config.isInAppFrame && 'table-cards-student-iframe'} ${isDrunk && 'pulse-blur'}`} /*style={{ left: 'unset', right: '11%', transform: 'scale(0.8)' }}*/>
        {items}
      </div>
    );
  }

  if (myPos === 'player2') {
    // table cards
    Object.keys(currentTable).map((key, index) => {
      if (currentTable[key] && currentTable[key].player === 'player1') {
        items.push(<div id={`table-card-${currentTable[key].card}`} className={`table-card card student-card-1 card-order-${index} table-card-${currentTable[key].card}`} />);
      }
      if (currentTable[key] && currentTable[key].player === 'player2') {
        items.push(<div id={`table-card-${currentTable[key].card}`} className={`table-card card student-card-0 card-order-${index} table-card-${currentTable[key].card}`} />);
      }
      if (isDrunk) {
        if (currentTable[key] && currentTable[key].player === 'player1') {
          items.push(<div id={`table-card-${currentTable[key].card}`} className={`${cardMoveClassesMiddle1[1]} table-card card student-card-1 card-order-${index} table-card-${currentTable[key].card}`} style={{opacity: 0.5}} />);
        }
        if (currentTable[key] && currentTable[key].player === 'player2') {
          items.push(<div id={`table-card-${currentTable[key].card}`} className={`${cardMoveClassesMiddle2[1]} table-card card student-card-0 card-order-${index} table-card-${currentTable[key].card}`} style={{opacity: 0.5}} />);
        }
      }
      return null;
    });

    // table card backgrounds
    if (currentTable && currentTable.length <= 2) {
    //  console.log('Render2PlayerCards 2', gameState, currentTurn, currentTable.length);

      if ((gameState !== 'burry' && currentTurn === 'player1') || (gameState === 'burry' && firstToGo === 'player1')) {
        items.push(<div className="table-card table-card-bg student-card-1" />);
        if (currentTable.length < 1) {
          items.push(<div className="table-card table-card-bg-after student-card-0" />);
        }
      } else if ((gameState !== 'burry' && currentTurn === 'player2') || (gameState === 'burry' && firstToGo === 'player2')) {
        items.push(<div className="table-card table-card-bg student-card-0" />);
        if (currentTable.length < 1) {
          items.push(<div className="table-card table-card-bg-after student-card-1" />);
        }
      }
    }

    return (
      <div className={`table-cards table-cards-student ${isDrunk && 'pulse-blur'}`} /*style={{ left: 'unset', right: '11%', transform: 'scale(0.8)' }}*/>
        {items}
      </div>
    );
  }

  return null;
});

Render2PlayerCards.propTypes = {
  currentTable: PropTypes.arrayOf(PropTypes.shape()),
  cardsAdded: PropTypes.shape(),
  myPos: PropTypes.string,
  isFullscreen: PropTypes.bool,
  isWebVersion: PropTypes.bool,
};

Render2PlayerCards.defaultProps = {
  currentTable: [],
  cardsAdded: {},
  myPos: '',
  isFullscreen: false,
  isWebVersion: false,
};

export default Render2PlayerCards;
